<template>
  <div>
    <Menu>
      <li class="menu-item">
        <a
          v-if="
            (domain && domain.permission && domain.permission >= 32) ||
              (domain && !domain.permissions)
          "
          @click="showDownload = true"
        >
          <IconText icon="mdi-download">Download installer</IconText>
        </a>
      </li>

      <li class="menu-item">
        <router-link
          v-if="domain && (!domain.permission || domain.permission >= 256)"
          :to="`/domains/${domain.uid}/shares`"
        >
          <IconText icon="mdi-account-multiple-plus">Share</IconText>
        </router-link>
      </li>

      <li class="menu-item">
        <router-link v-if="domain" :to="`/domains/${domain.uid}/applications`">
          <IconText icon="mdi-format-list-checks">Applications</IconText>
        </router-link>
      </li>
    </Menu>

    <Groups :domain="domain"></Groups>
    <Computers :domain="domain"></Computers>
    <Msi
      v-if="showDownload && domain"
      v-model="showDownload"
      @hide="showDownload = $event"
      @success="
        isDownloaded = true;
        $store.state.computer.computers.length === 0
          ? (showGuide = true)
          : false;
      "
      :domain="domain"
    ></Msi>

    <StartGuide v-if="step > 0" v-model="showGuide" :step="step">
      <p v-if="step == 3" class="has-text-centered">
        <a
          @click.stop="
            showGuide = false;
            showDownload = true;
          "
        >
          Click here to download the computer agent</a
        >.
      </p>

      <p v-if="step == 4" class="has-text-centered">
        Install the agent on a computer that you would like to add in this domain ({{
          domain.friendlyName
        }}).
      </p>

      <div v-if="step == 5" class="has-text-centered">
        <div class="margin-bottom-30">
          <animated-check></animated-check>
        </div>
        <p>
          Nice! All you have to do now is to click on a computer, and start
          deploying applications.
        </p>
      </div>
    </StartGuide>
  </div>
</template>

<script>
import "vue-context/src/sass/vue-context.scss";

export default {
  components: {
    Computers: () => import("@/components/main/computer/Section.vue"),
    Groups: () => import("@/components/main/group/Section.vue"),
    Msi: () => import("@/components/main/domain/Msi.vue"),
    Menu: () => import("@/components/main/Menu.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
    AnimatedCheck: () => import("@/components/singles/AnimatedCheck.vue"),
    StartGuide: () => import("@/components/main/user/StartGuide.vue"),
  },
  computed: {
    step() {
      if (!this.isLoading && this.guideActive()) {
        if (
          this.$store.state.computer.computers.length === 0 &&
          !this.isDownloaded
        )
          return 3;
        if (
          this.$store.state.computer.computers.length === 0 &&
          this.isDownloaded
        )
          return 4;
        else if (this.$store.state.computer.computers.length === 1) return 5;
      }

      return -1;
    },
  },
  data() {
    return {
      isLoading: false,
      domain: null,
      showDownload: false,
      showGuide: false,
      isDownloaded: false,
    };
  },
  beforeDestroy() {
    this.$store.commit("groupPackage/clear");
    this.$store.commit("group/clear");
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch("computer/fetch", {
        domainUID: this.$route.params.domainUID,
      });

      this.checkGuide();

      await this.$store.dispatch("domain/fetch");
      this.domain = this.$store.getters["domain/single"](
        this.$route.params.domainUID
      );
    } catch (err) {
      console.log(err);
      this.$helpers.notify("Error", "Could not get data.", "danger", 5000);
    }

    this.isLoading = false;
  },
  methods: {
    checkGuide() {
      if (
        this.$store.state.computer.computers.length === 0 &&
        this.guideActive()
      ) {
        this.showGuide = true;
      } else if (this.$store.state.computer.computers.length === 0) {
        this.showDownload = true;
      }
    },
    guideActive() {
      return (
        this.$store.state.settings.user?.profile?.guides?.getStarted ===
          undefined ||
        this.$store.state.settings.user?.profile?.guides?.getStarted
      );
    },
  },
};
</script>
